<template>
  <div class="base-timeline-skeleton">
    <div class="event"><span /><span /></div>
    <div class="event"><span /><span /></div>
    <div class="event"><span /><span /></div>
    <div class="event"><span /><span /></div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({ name: "BaseTimelineSkeleton" });
</script>
<style lang="scss" scoped>
.base-timeline-skeleton {
  height: 322px;
  display: flex;
  flex-direction: column;
  margin-top: 18px;
  width: 430px;

  .event {
    border-radius: 3px;
    margin-bottom: 12px;
    padding: 32px 24px;
    display: flex;
    flex-basis: 60%;
    flex-grow: 1;
    position: relative;

    @include themed() {
      background: t($bg-hover);
    }

    &::after {
      position: absolute;
      top: 0;
      inset-inline-end: 0;
      bottom: 0;
      inset-inline-start: 0;
      transform: translateX(-100%);
      animation: shimmer 5s infinite;
      content: "";
      @include themed() {
        background-image: linear-gradient(
          90deg,
          rgba(t($bg), 0) 0,
          rgba(t($bg), 0.2) 40%,
          rgba(t($bg), 0.5) 90%,
          rgba(t($bg), 0)
        );
      }
    }

    @keyframes shimmer {
      100% {
        transform: translateX(100%);
      }
    }

    span {
      display: block;
      opacity: 0.6;
      width: 140px;
      height: 6px;
      border-radius: 5px;
      @include themed() {
        background: t($grey-15);
      }
    }

    span:first-child {
      width: 32px;
      opacity: 0.5;
      margin-inline-end: 24px;
    }
  }
}
</style>
